import {Injectable} from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import * as XLSXStyle from 'xlsx-style';
import * as Excel from "exceljs/dist/exceljs.min.js";

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable()
export class ExceldownloadService {
  private approvedCell = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: '9ce089' }
  };
  private rejectedCell = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'e08989' }
  };
  private headerCell = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: '8398e6' }
  };
    constructor() {}


    public ExportRejectFile(json: any[]){
      const workbook = new Excel.Workbook();
      const worksheet = workbook.addWorksheet('Data');
      worksheet.columns = [
        { header: 'VIN', key: 'vin', width: 20, height: 20},
        { header: 'FIRST NAME', key: 'first_name', width: 30, height: 20 },
        { header: 'LAST NAME', key: 'last_name', width: 30, height: 20 },
        { header: 'EMAIL', key: 'email', width: 30, height: 20 },
        { header: 'MOBILE PHONE', key: 'mphone', width: 20, height: 20 },
        { header: 'HOME PHONE', key: 'hphone', width: 20, height: 20 },
        { header: 'DEALER CODE', key: 'dealer', width: 20, height: 20 },
        { header: 'REASON', key: 'reason', width: 90, height: 20 },
      ];
      const headerPos =  ['A1','B1','C1','D1','E1', 'F1', 'G1' ,'H1'];
      headerPos.map(key => {
        worksheet.getCell(key).fill = this.headerCell;
        worksheet.getCell(key).border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
      });
      for (const row of json) {
        let addedRow=worksheet.addRow(row);
        if(row.reason.length>0){
          addedRow.eachCell((cell, colNumber) => {
            cell.fill=this.rejectedCell;
          })
        }else{
          addedRow.eachCell((cell, colNumber) => {
            cell.fill=this.approvedCell;
          })
        }
        //Commit the changed row to the stream
        addedRow.commit();
      }
      workbook.xlsx.writeBuffer( {
        base64: true
      })
        .then( function (xls64) {
          // build anchor tag and attach file (works in chrome)
          var a = document.createElement("a");
          var data = new Blob([xls64], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

          var url = URL.createObjectURL(data);
          a.href = url;
          a.download = "rejectedData.xlsx";
          document.body.appendChild(a);
          a.click();
          setTimeout(function() {
              document.body.removeChild(a);
              window.URL.revokeObjectURL(url);
            },
            0);
        })
        .catch(function(error) {
          console.log(error.message);
        });
    }
    public exportAsExcelFile(json: any[], excelFileName: string): void {
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
        this.wrapAndCenterCell(worksheet.B2);
        const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
        // Use XLSXStyle instead of XLSX write function which property writes cell styles.
        const excelBuffer: any = XLSXStyle.write(workbook, {bookType: 'xlsx', type: 'buffer'});
        this.saveAsExcelFile(excelBuffer, excelFileName);
    }

    private wrapAndCenterCell(cell: XLSX.CellObject) {
        const wrapAndCenterCellStyle = {alignment: {wrapText: true, vertical: 'center', horizontal: 'center'}};
        this.setCellStyle(cell, wrapAndCenterCellStyle);
    }

    private setCellStyle(cell: XLSX.CellObject, style: {}) {
        cell.s = style;
    }

    private saveAsExcelFile(buffer: any, fileName: string): void {
        const data: Blob = new Blob([buffer], {
            type: EXCEL_TYPE
        });
        FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
    }

}



// WEBPACK FOOTER //
// ./src/app/modules/housekeeping/services/exceldownload.service.ts